import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
    //  로그인 전에 사용하는 Vue 파일
    {
        path: "/",
        name: "Login&Register",
        component: () => import("../views/Login&Register.vue")
    },
    {
        path: "/user/find",
        name: "UserFind",
        component: () => import("../views/UserFind.vue")
    },
    {
        path: "/user/find/id",
        name: "UserFindId",
        component: () => import("../views/UserFindId.vue")
    },
    {
        path: "/user/find/pw",
        name: "UserFindPw",
        component: () => import("../views/UserFindPw.vue")
    },
    {
        path: "/user/find/pw/reset",
        name: "UserFindPwReset",
        component: () => import("../views/UserFindPwReset.vue")
    },

    // 로그인 후에 사용하는 Vue 파일
    {
        path: "/home",
        name: "Home",
        component: () => import("../views/Home.vue")
    },
    {
        path: "/floor",
        name: "Floor",
        component: () => import("../views/Floor.vue")
    },
    {
        path: "/information",
        name: "Information",
        component: () => import("../views/Information.vue")
    },
    {
        path: "/information/detail",
        name: "InformationDetail",
        component: () => import("../views/InformationDetail.vue")
    },
    {
        path: "/inquiry/register",
        name: "InquiryRegister",
        component: () => import("../views/InquiryRegister.vue")
    },
    {
        path: "/inquiry/list",
        name: "InquiryList",
        component: () => import("../views/InquiryList.vue")
    },
    {
        path: "/faq/list",
        name: "Faq",
        component: () => import("../views/FaqList.vue")
    },
    {
        path: "/notice/list",
        name: "NoticeList",
        component: () => import("../views/NoticeList.vue")
    },
    {
        path: "/notice/detail/:id",
        name: "NoticeDetail",
        component: () => import("../views/NoticeDetail.vue")
    },
    {
        path: "/event/list",
        name: "EventList",
        component: () => import("../views/EventList.vue")
    },
    {
        path: "/event/detail/:id",
        name: "EventDetail",
        component: () => import("../views/EventDetail.vue")
    },
    {
        path: "/service",
        name: "Service&History",
        component: () => import("../views/Service&History.vue")
    },
    {
        path: "/service/reservation/:id",
        name: "ServiceReservation",
        component: () => import("../views/ServiceReservation.vue")
    },
    {
        path: "/point",
        name: "Point&History",
        component: () => import("../views/Point&History.vue")
    },
    {
        path: "/point/menu/:id",
        name: "PointMenu",
        component: () => import("../views/PointMenu.vue")
    },
    {
        path: "/payment/list",
        name: "PaymentList",
        component: () => import("../views/PaymentList.vue")
    },
    {
        path: "/point/list",
        name: "PointList",
        component: () => import("../views/PointList.vue")
    },
    {
        path: "/user/leave",
        name: "UserLeave",
        component: () => import("../views/UserLeave.vue")
    },
    {
        path: "/policy",
        name: "Policy",
        component: () => import("../views/Policy.vue")
    },
    {
        path: "/privacy",
        name: "Privacy",
        component: () => import("../views/Privacy.vue")
    },
    {
        path: "*",
        name: "404",
        component: () => import("../views/404.vue")
    }
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

// * 전역 route guard
// * router에서 페이지로 넘어가기전 실행되는 Hook
router.beforeEach((to, from, next) => {

    // * 이용약관, 개인정보 처리방침은 프리패스
    console.log(to.name);
    if (to.name === "Policy" || to.name === "Privacy") {
        console.log("=========Pass========");
        next();
        return;
    } else {
        console.log("=========Auth========");
        // * <Step_1>
        // * 인증 없이 들어갈 수 있는 route 이름 배열
        const public_route_names = ["Login&Register", "UserFind", "UserFindId", "UserFindPw", "UserFindPwReset", "404"];

        // * 현재 router의 name이 위의 배열에 속하지 않으면 false 반환 => !false => true
        const is_auth_page = !public_route_names.includes(to.name);

        // * <Step_2>
        const is_login = () => {
            // * accessToken, userInfo의 pk, 이름 중 하나라도 존재하지 않으면 로그인이 아니라고 가정
            if (!store.state.accessToken || !store.state.userInfo.name || !store.state.userInfo.email || !store.state.userInfo.pk) {
                return false;
            } else {    // * 모든 값이 있을때 로그인 중이라고 가정
                return true;
            }
        };

        if (to.path === "/" && is_login()) {
            next("/home");
        }

        if (is_auth_page && !is_login()) {
            next("/");
        } else {
            next();
        }
    }
});

// * router에서 페이지 이동이 완료된 후 실행되는 Hook
// * Vue components에서 beforeCreate() 함수보다 먼저 실행됨
router.afterEach(() => {
    window.scrollTo(0, 0);
});

export default router;
